import { WeatherNightIcon } from './WeatherNightIcon';

/**
 * author: Austin Andrews
 * id 1C3BA3AB-E86E-481B-A3C2-867B37A6E55A
 * name weather-night
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-night.svg
 * tags
 * - Weather 
 * - Holiday 
 */
export const NightSkyIcon = WeatherNightIcon;
export default NightSkyIcon